<app-page-title pageTitle="EAUTHORISATION-OVERVIEW.FAQ.TITLE"></app-page-title>

<div class="faq-container section-p">
    <div class="main-box-style">
        <div class="steps-container">
            <ol start="1" type="1">
                <li>
                    <strong>Koji su preduvijeti za prijavu na e-uslugu e-Ovlaštenja?</strong>
                </li>
            </ol>
                <p>
                <span>Za korištenje e-Ovlaštenja, Korisnik mora osigurati:</span>
                </p>
            <ul>
                <li>
                    <span>osobno računalo,</span>
                </li>
                <li>
                    <span>pristup Internetu,</span>
                </li>
                <li>
                    <span
                    >preporučeni operacijski sustavi: Microsoft Windows 7, Microsoft Windows
                    8, Microsoft Windows 10,</span
                    >
                </li>
                <li>
                    <span>internet preglednik: Google Chrome v51 i više,</span>
                    <span></span>
                </li>
                <li>
                    <span>vjerodajnicu visoke razine sigurnosti,</span>
                </li>
                <li>
                    <span
                    >instaliranu programsku podršku za korištenje naprednog elektroničkog
                    potpisa (za potpisivanje Dokumenta ovlaštenja za e-usluge koje zahtjevaju
                    elektronički potpis),</span
                    >
                </li>
                <li>
                    <span
                    >kvalificirani certifikat za elektronički potpis i certifikat za
                    autentikaciju</span
                    >
                    <span
                    >(za potpisivanje Dokumenta ovlaštenja koje zahtjevaju elektronički
                    potpis),</span
                    >
                </li>
                <li>
                    <span
                    >programsku podršku za korištenje digitalnih certifikata (ovisno o
                    izdavatelju čija se vjerodajnica koristi za elektroničko potpisivanje
                    Dokumenta ovlaštenja),</span
                    >
                </li>
                <li>
                    otvoren Korisnički pretinac (KP) jer se komunikacija između e-Ovlaštenja i
                    Korisnika odvija putem KP-a. Prilikom prve prijave Korisnika na e-uslugu
                    e-Ovlaštenja, aplikativno se kontrolira ima li Korisnik otvoren KP, te se
                    Korisniku koji nema otvoren KP automatski nudi njegovo otvaranje.
                </li>
            </ul>

            <ol start="2" type="1">
                <li>
                    <strong>Kako se mogu prijaviti na e-uslugu e-Ovlaštenja?</strong>
                </li>
            </ol>
            <div>
                <p>
                <span
                    >E-usluzi e-Ovlaštenja može se pristupiti na Portalu e-Građani kroz opciju
                    &bdquo;Filtrirajte e-usluge&ldquo; ili kroz Katalog usluga. Korisnik se može
                    prijaviti osobnom ili poslovnom vjerodajnicom visoke razine sigurnosti koja
                    je integrirana na NIAS. Kod prijava osobnom vjerodajnicom, na Navigacijskoj
                    traci Korisniku se nudi popis svih poslovnih subjekata u čije ime može
                    djelovati. Kod prijave poslovnom vjerodajnicom, Korisniku se nudi popis
                    poslovnih subjekata povezanih s poslovnim subjektom s vjerodajnice u čije
                    ime može djelovati.</span
                >
                </p>
                <p>
                <span
                    >E-Ovlaštenja će dopustiti pristup svakog Korisnika s odabranim poslovnim
                    subjetkom ali će unutar same usluge kod funkcionalnosti davanja ovlaštenja
                    kontrolirati je li Korisnik ovlaštena osoba i/ili ima dodijeljna prava
                    zastupanja unutar e-Ovlaštenja.</span
                >
                </p>
                <p>
                <span>
                    <strong></strong>
                </span>
                </p>
            </div>
            <ol start="3" type="1">
                <li>
                    <strong
                    >Mogu li se prijaviti osobnom vjerodajnicom na e-uslugu
                    e-Ovlaštenja?</strong
                    >
                </li>
            </ol>
            <p>
            <span
                >Na e-uslugu e-Ovlaštenja Korisnik se može prijaviti osobnim i poslovnim
                vjerodajnicama visoke razine sigurnosti. Kod prijave osobnom vjerodajnicom
                na e-Ovlaštenja na Navigacijskoj treci prikazati će se popis svih poslovnih
                subjekta povezanih sa Korisnikom, dohvatljivih iz nadležnih registara.
                Korisnik na Navigacijskoj traci bira poslovni subjekt u čije ime želi
                djelovati na e-Ovlaštenjima.</span
            >
            </p>

            <ol start="4" type="1">
            <li>
                <strong
                >Zašto se na Navigacijskoj traci prikazuju različiti skup poslovnih
                subjekata ako e-Ovlaštenjima pristupam poslovnom ili osobnom
                vjerodajnicom?</strong
                >
            </li>
            </ol>
            <p>
            <span
                >Kod prijave osobnom vjerodajnicom na e-uslugu e-Ovlaštenja na Navigacijskoj
                traci prikazati će se popis svih poslovnih subjekta u čije ime Korisnik može
                djelovati (kao ovlaštena osoba i/ili Opunomoćenik za neku e-uslugu).</span
            >
            </p>
            <p>
            <span
                >Kod prijave poslovnom vjerodajnicom na e-uslugu e-Ovlaštenja na
                Navigacijskoj traci prikazati će se popis onih poslovnih subjekta koji su
                povezani s Korisnikom i poslovnim subjektom sa vjerodajnice u čije ime
                Korisnik može djelovati.</span
            >
            </p>

            <ol start="5" type="1">
            <li>
                <strong
                >Na e-Ovlaštenja prijavljujem se osobnom vjerodajnicom. Ovlaštena sam
                osoba nekog poslovnog subjekta ali tog subjekta nema prikazanog u odabiru
                na Navigacijskoj traci?</strong
                >
            </li>
            </ol>
            <p>
            <span>Podaci o vezi Korisnika i poslovnih subjekata dohvaćaju se iz nadležnih registara: za pravne osobe iz OIB sustava (podaci iz Sudrega i registra udruga), za obrtnike iz Obrtnog registra, za obiteljska poljoprivredna gospodarstva iz Upisnika poljoprivrednika te za proračunske i izvanproračunske korisnike državnog proračuna i proračunske i izvanproračunske korisnike proračuna jedinica lokalne i područne (regionalne) samouprave iz Registra proračunskih i izvanproračunskih korisnika. Za kategorije slobodna djelatnosti i sporedna zanimanja ne postoji nadležan registar nego se podaci unose u sustav e-Ovlaštenja kroz podršku Referenta e-Ovlaštanja, dostavom propisane dokumentacije koja dokazuje vezu Korisnika – ovlaštene osobe i poslovnog subjekta.</span
            >
            </p>
            <p>
            <span
                >Ako Korisnik koji je ovlaštena osoba poslovnog subjekta pravne osobe,
                slobodne djelatnosti ili sporednog zanimanja na Navigacijskoj traci ne vidi
                poslovni subjekt a prijavio se odgovarajućom vjerodajnicom (osobnom ili
                poslovnom vjerodajnicom tog poslovnog subjekta) može kroz podršku Referenta
                e-Ovlaštenja regulirati vezu on-line putem (preko aplikacije Online sustav
                za dostavu dokumentacije &ndash; OSPD na linku
            </span>
            <a href="https://ospd.fina.hr/">https://ospd.fina.hr/</a>
            <span>).</span>
            </p>
            <p>
            <span
                >Korisnik Referentu e-Ovlaštenja treba dostaviti dokumentaciju kojom
                dokazuje da je on ovlaštena osoba poslovnog subjekta (npr. Izvadak iz
                Sudskog registra, Rješenje Gradskog ureda ili sl.), Suglasnost za unos
                podataka o poslovnom subjektu i ovlaštenim osobama poslovnog subjekta u
                sustav e-Ovlaštenja te kopije identifikacijske isprave za sve ovlaštene
                osobe poslovnog subjekta).</span
            >
            </p>

            <p>
            <span
                >Ako Korisnik koji je ovlaštena osoba poslovnog subjekta obrta, obiteljskog poljoprivrednog gospodarstva i proračunskog i izvanproračunskog korisnika na Navigacijskoj traci ne vidi poslovni subjekt a prijavio se odgovarajućom vjerodajnicom (osobnom ili poslovnom vjerodajnicom tog poslovnog subjekta), tada se treba obratiti nadležnom registru.</span
            >
            </p>

            <ol start="6" type="1">
            <li>
                <strong
                >Zašto se kod prijave na e-Ovlaštenja na Navigacijskoj traci isti poslovni
                subjekt prikazuje nekoliko puta?</strong
                >
            </li>
            </ol>
            <p>
            <span
                >Korisnik kod odabira subjekta na Navigacijskoj traci vidi samo poslovni
                subjekt u čije ime želi djelovati. U pozadini se na Navigacijskoj traci
                nalazi dva poslovna subjekta - poslovni subjekt u čije ime želi djelovati i
                poslovni subjekt s kojim Korisnik može djelovati za prvi poslovni subjekt
                (može biti isti ili različit od prvog). Kada za jedan poslovni subjekt
                Korisnik može djelovati s više različitih poslovnih subjekta, može se
                dogoditi da se na Navigacijskoj traci prikazuje isti poslovni subjekt
                nekoliko puta.</span
            >
            </p>
            <p>
            <span>
                Kod provjere prava e-usluga kontrolira ima li Korisnik prava djelovanja u
                ime poslovnog subjekta kao odabrani poslovni subjekt.</span
            >
            </p>

            <ol start="7" type="1">
            <li>
                <strong
                >Nisam ovlaštena osoba niti imam dodijeljena prava za rad na
                e-Ovlaštenjima. Mogu li koristiti e-uslugu e-Ovlaštenja?</strong
                >
            </li>
            </ol>
            <p>
            <span
                >E-usluga e-Ovlaštenja je poslovna e-usluga koju može koristiti isključivo
                Korisnik koji je povezan s nekim poslovnim subjektima.</span
            >
            </p>

            <ol start="8" type="1">
            <li>
                <strong
                >Zašto je bitno dati suglasnost za prosljeđivanje osobnih podataka izvan
                sustava e-Ovlaštenja?</strong
                >
            </li>
            </ol>
            <p>
            <span
                >Glavna funkcionalnost e-Ovlaštenja je da prilikom pristupa Korisnika na
                neku e-uslugu, prosljeđuje Navigacijskoj traci i integriranim e-uslugama
                skup podataka o zastupanjima i/ili pristupu na e-uslugu, ovisno što e-usluga
                zatraži. U tom skupu podataka nalaze se osobni podaci Korisnika. Sukladno
                GDPR uredbi, Korisnik svjesno treba dati suglasnost da se njegovi osobni
                podatci prosljeđuju izvan e-Ovlaštenja integriranim e-uslugama. Ako ta
                suglasnost nije dana, e-usluga može odbiti pristup Korisnika iako Korisnik
                ima potrebna prava pristupa i role za rad na navedenoj e-usluzi.</span
            >
            </p>

            <ol start="9" type="1">
            <li>
                <strong
                >Može li ovlaštena osoba poslovnog subjekt koja nema HR OIB koristiti
                e-uslugu e-Ovlaštenja?</strong
                >
            </li>
            </ol>
            <p>
            <span
                >Ovlaštena osoba poslovnog subjekta bez HR OIB-a ne može koristiti
                e-Ovlašenja. Potrebno je od nadležnih institucija zatražiti izdavanje HR
                OIB-a, te zadovoljiti ostale preduvjete za korištenje e-usluge.</span
            >
            </p>

            <ol start="10" type="1">
            <li>
                <strong
                >Kod pristupa na ekran Zastupanja/Pristupa na e-usluge sustav javlja
                poruku &bdquo;Niste ovlašteni za davanje prava zastupanja unutar
                e-Ovlaštenja/pristupa na e-usluge&ldquo;.</strong
                >
            </li>
            </ol>
            <p>
            <span
                >Za pristup na ekran Zastupanja/Pristup na e-usluge Korisnik treba biti ovlaštena osoba – imati zakonsko ili dodijeljeno pravo na e-Ovlaštenjima. U „Pregledu ovlaštenih osoba“ vidljive su sve ovlaštene osobe poslovnog subjekta – osobe koje imaju zakonsko (ovlaštene osobe koje su tako definirane u mjerodavnim registrima) i dodijeljeno pravo (osobe koje su dobile pravo zastupanja na e-Ovlaštenja). U pregledu su uz ovlaštene osobe upisani njihovi izvori podataka. Izvori podataka zakonski ovlaštenih osoba su OIB sustav (Sudski registar, Državni zavod za statistiku, Ministarstvo pravosuđa i uprave), Obrtni registar, Upisnik poljoprivrednika, Registar proračunskih i izvanproračunskih korisnika i e-Ovlaštenja (podaci koje unosi Referent temeljem dokumentacije od Korisnika). Izvor podataka dodijeljenog prava je e-Ovlaštenje – dobiveno pravo zastupanja na e-Ovlaštenjima.</span
            >
            </p>
            <p>
            <span
                >Za pristup na ekran Zastupanja dodijeljeno pravo treba biti prenosivo.
                Oznaka prenosivosti prava vidljiva je na Dokumentu ovlaštenja.</span
            >
            </p>

            <ol start="11" type="1">
            <li>
                <strong
                >Ovlaštena sam za zastupanje poslovnog subjekta, ali unutar e-usluge ne
                mogu odabrati Pristup na e-uslugu?</strong
                >
            </li>
            </ol>
            <p>
            <span
                >Ako ovlaštena osoba za zastupanje poslovnog subjekta (vidljivo u Pregledu
                ovlaštenih osoba) ne može odabrati Pristup na e-uslugu, a može Zastupanja,
                moguće je da Korisnik nije dao posebnu suglasnost za prosljeđivanje osobnih
                podataka izvan e-Ovlaštenja integriranim e-uslugama. Ta suglasnost je
                opcionalna i daje se unutar Uvjeta korištenja sustava e-Ovlaštenja.</span
            >
            </p>

            <ol start="12" type="1">
            <li>
                <strong>što znači prenosivo ovlaštenje?</strong>
            </li>
            </ol>
            <p>
            <span
                >Ovlaštenje kojim se daje pravo zastupanja unutar poslovnog subjekta u
                e-Ovlaštenjima može biti prenosivo, odnosno može se definirati do tri osobe
                koje su ovlaštene osobe za zastupanje poslovnog subjekta (1. Zakonski
                ovlaštena osoba, 2. Osoba koja je dobila prenosivo pravo zastupanja od
                ovlaštene osobe, 3. Osoba koja je dobila pravo zastupanja od osobe koja ima
                prenosivo pravo zastupanja). Kod davanja ovlaštenja, prenosivo ovlaštenje se
                označuje odabirom &bdquo;prenosivo ovlaštenje&ldquo;. Oznaka prenosivosti
                prava vidljiva je na Dokumentu ovlaštenja.</span
            >
            </p>

            <ol start="13" type="1">
            <li>
                <strong>Može li se dati ovlaštenje za određeno razdoblje važenja?</strong>
            </li>
            </ol>
            <p>
            <span
                >Kod davanja prava zastupanja na e-Ovlaštenjima može se odrediti vrijeme
                važenja ovlaštenja &ndash; indikativno vrijeme početka (ovisno o tome kada
                je potpisan Dokument ovlaštenja od strane Opunomoćenika) i završetka
                važenja. Ako se to ne odredi, ovlaštenje za zastupanje vrijedi od potpisa
                Opunomoćenika do opoziva.</span
            >
            </p>
            <p>
            <span
                >Kod davanja Punomoći za pristup na e-usluge, ovlaštenje vrijedi od
                potpisa/potvrde Opunomoćenika do ukidanja prava bez mogućnosti
                definiranjaperiodavaženja, osim ako je to usluga predvidjela na Web
                registracijskom obrascu.</span
            >
            </p>

            <ol start="14" type="1">
            <li>
                <strong
                >Zašto se prilikom davanja prava zastupanja/pristupa na e-uslugu za
                Opunomoćenika unose podaci OIB + ime + prezime, zašto nije dovoljan samo
                OIB Opunomoćenika?</strong
                >
            </li>
            </ol>
            <p>
            <span
                >Kod unosa podataka o Opunomoćeniku obavezno se unosi kombinacija OIB + ime
                + prezime. Sustav provjerava je li kombinacija dobro unesena i postoje li
                navedeni podaci u OIB sustavu. Zbog GDPR odredbi i zaštite osobnih podataka
                nije dovoljno unijeti samo podatak o OIB-u Opunomoćenika.</span
            >
            </p>

            <ol start="15" type="1">
            <li>
                <strong
                >Mogu li se unutar e-Ovlaštenja dodijeljivati punomoći za pristup na
                e-usluge drugoj fizičkoj osobi?</strong
                >
            </li>
            </ol>
            <p>
            <span
                >E-Ovlaštenja su poslovna usluga namijenjena fizičkim osobama unutar
                poslovnog subjekta, te nije omogućeno davanje prava zastupanja za
                e-Ovlaštenja niti pristupa na e-usluge drugoj fizičkoj osobi koja nije
                povezana s nekim poslovnim subjektom.</span
            >
            </p>

            <ol start="16" type="1">
            <li>
                <strong
                >Kako se unutar unutar e-Ovlaštenja mogu dodijeljivati punomoći za pristup
                na e-usluge odvjetniku?</strong
                >
            </li>
            </ol>
            <p>
            <span
                >Odvjetnici su kategorija poslovnih subjekata koji mogu djelovati kao pravne
                osobe ili kao samostalne djelatnosti.</span
            >
            </p>
            <p>
            <span
                >Kada odvjetnik djeluje kao pravna osoba, proces davanja punomoći provodi se
                sukladno Korisničkoj uputi za e-Ovlaštenja.</span
            >
            </p>
            <p>
            <span
                >Ako odvjetnik djeluje kao samostalna djelatnost, preduvjet je da u sustavu
                e-Ovlaštenja bude registriran kao poslovni subjekt &ndash; samostalna
                djelatnost.Po registraciji samostalne djelatnosti u sustav e-Ovlaštenja,
                proces dodijele punomoći se nastavlja sukladno Korisničkoj uputi za
                e-Ovlaštenja.</span
            >
            </p>

            <ol start="17" type="1">
            <li>
                <strong
                >O čemu ovisi dodijeljuju li se prava pristupa na e-uslugu na OIB
                Korisnika ili DN certifikata?</strong
                >
            </li>
            </ol>
            <p>
            <span
                >Prilikom integracije e-usluge na e-Ovlaštenja, svaka e-usluga definira
                dodijeljuju li se prava pristupa na e-usluge na DN certifikata ili na
                kombinaciju OIB-ova Opunomoćenika i jedinstvenog identifikatora poslovnog
                subjekta (JIPS).</span
            >
            </p>
            <p>
            <span
                >Za pristup na e-uslugu koja je definirala da se prava dodijeljuju po DN
                certifikata, prilikom davanja prava pristupa Opunomoćitelj treba odabrati iz
                ponuđene listeodređeni DN certifikata Opunomoćenika kojim će Opunomoćenik
                moći potpisati Dokument ovlaštenja kojim dobiva navedena prava pristupa i
                kasnije s tim DN certifikatom pristupiti na tu e-uslugu.</span
            >
            </p>
            <p>
            <span
                >Za pristup na e-uslugu koja je definirala da se prava dodijeljuju po kombinaciji OIB-ova, prilikom davanja prava Opunomoćitelj ne navodi DN certifikata, već unosi podatke o Korisniku i poslovnom subjektu kojemu pripada Korisnik. U tom slučaju opunomoćenik nije ograničen DN-om certifikata kako bi potpisao primljeni ovlaštenje te koristio e-uslugu.</span
            >
            </p>

            <ol start="18" type="1">
            <li>
                <strong>što je Web autorizacijski obrazac?</strong>
            </li>
            </ol>
            <p>
            <span
                >Web autorizacijski obrazac je forma na kojemu svaka e-usluga definira role
                (prava) koje Korisnik može imati na toj e-usluzi. E-usluga također na Web
                autorizacijskom obrascu može definirati kontrole koje smatra potrebnim, te
                samim time ograničiti korištenje e-usluge ovisno o definiranim
                kontrolama.</span
            >
            </p>
            <p>
            <span
                >Web autorizacijski obrazac dohvatljiv je Korisniku u e-Ovlaštanjima nakon
                što na ekranu za Pristup na e-uslugu definira osnovne podatke o
                Opunomoćeniku kojemu se daje pravo pristupa za tu e-uslugu .</span
            >
            </p>
            <p>
            <span
                >Podatke na Web autorizacijskom obrascu je također potrebno spremiti nakon
                čega se podaci s Web registracijskog obrasca pohranjuju u Dokument
                ovlaštenja koji je unutare-Ovlaštenja potrebno potpisati/potvrditi. Ovakav
                dokument dostupan je Korisniku na uvid u pregledu danih/primljenih
                ovlaštenja.</span
            >
            </p>

            <ol start="19" type="1">
            <li>
                <strong
                >Prilikom davanja prava pristupa na e-uslugu nakon pokušaja spremanja
                podataka na Web registracijskom obrascu pojavila se greška.</strong
                >
            </li>
            </ol>
            <p>
            <span
                >Web registracijski obrazac definira e-usluga te ukolikose pojavigreška ili porukapotrebno je obratiti se pružatelju e-usluge.Savjetujemo da se Korisnik obratiti kontakt centru e-usluge i prijavi grešku. Često e-usluge na Web registracijski obrazac stavljaju kontrole koje su isključivo pod njihovom nadležnošču.</span
            >
            </p>

            <ol start="20" type="1">
            <li>
                <strong
                >Što kada Opunomoćenik i/ili Supotpisnik nema otvoreni Korisnički
                pretinac?</strong
                >
            </li>
            </ol>
            <p>
            <span
                >Ukoliko Korisnik želikoristi e-Ovlaštenja, preduvjet je otvoren Korisnički pretinac. Sve poruke koje razmijenjuje sustav šalju se Korisniku u njegov Korisnički pretinac (davanja, primanja, poništavanja, ukidanja/opoziva, istek trajanja ovlaštenja i sl.). U trenutku pristupa Korisnika na e-Ovlaštenja, biti će mu ponuđeno otvaranje istog, ukoliko ga već nije otvorio.</span
            >
            </p>
            <p>
            <span
                >U situacijama kada Opunomoćenik i/ili Supotpisnik nemaju otvoreni Korisnički pretinac, Opunomoćiteljuće se kod davanja prava zastupanja ili pristupa na e-usluge ponuditi mogućnostunosa e-mail adrese Opunomoćenika i/ili Supotpisnika na koju će isti dobiti obavijest o pokušaju slanja poruke od strane sustava e-Ovlaštenja. Kako bi Opunomoćenik/Supotpisnik zaprimio poruku te kako bi mu se omogućilo korištenje e-Ovlaštenja nužno je otvaranje Korisničkog pretinca.</span
            >
            </p>
            <p>
            <span
                >Prihvat same poruke koja je poslana u Korisnički pretinac nije preduvijet
                za korištenje e-Ovlaštenja, već samo otvaranje Korisničkog pretinca.</span
            >
            </p>

            <ol start="21" type="1">
            <li>
                <strong>Kada Dokument ovlaštenja postaje aktivan?</strong>
            </li>
            </ol>
            <p>
            <span
                >Dokument ovlaštenja postaje aktivan kada su ga potpisali/potvrdili svi
                potrebni sudionici i kada je nastupio datum važenja ovlaštenja.</span
            >
            </p>

            <ol start="22" type="1">
            <li>
                <strong
                >S kojim se certifikatom mogu potpisati prava u e-usluzi
                e-Ovlaštenja?</strong
                >
            </li>
            </ol>
            <p>
            <span
                >U e-Ovlaštenjima Dokument ovlaštenja s danim/dobivenim pravima može se
                potpisati bilo kojim poslovnim ili osobnim certifikatom s elektroničkim
                potpisom bez obzira na izdavatelja certifikata.</span
            >
            </p>

            <ol start="23" type="1">
            <li>
                <strong
                >O čemu ovisi treba li se Dokument ovlaštenja elektronički potpisati ili
                samo potvrditi?</strong
                >
            </li>
            </ol>
            <p>
            <span
                >Prilikom integracije e-usluge na e-Ovlaštenja, svaka e-usluga definira
                treba li se Dokument ovlaštenja za pristup na e-uslugu elektronički
                potpisati ili je isti dovoljno samo potvrditi, kako bi isti bio aktivan.
                Usluga također kod opcije potvrde može definirati treba li Dokument
                potpisati Opunomoćitelj i Opunomoćenik, ili je za aktivaciju Dokumenta
                ovlaštenja dovoljna samo potvrda Opunomoćitelja. Podatak o tome, je li
                potreban potpis ili potvrda vidljiv je na ekranu Pristup na e-uslugu, nakon
                što Opunomoćitelj odabere e-uslugu za koju želi dati prava pristupa.</span
            >
            </p>
            <p>
            <span>Pravila u procesu skupnog potpisivanja/potvrde su identična.</span>
            </p>

            <ol start="24" type="1">
            <li>
                <strong
                >Kod potpisa dokumenta ovlaštenja pojavila se poruka &bdquo;Neispravan
                status odgovora PKI Applet servisa (0)&ldquo;. što to znači?</strong
                >
            </li>
            </ol>
            <p>
            <span
                >Navedena poruka javlja se zbog toga što nije instalirana podrška za
                korištenje naprednog elektroničkog potpisa. Za instalaciju podrške Korisnik
                se treba obratiti izdavatelju svoje vjerodajnice.</span
            >
            </p>

            <ol start="25" type="1">
            <li>
                <strong
                >Kako se potpisuje/potvrđuje Dokument ovlaštenja ako je u Sudskom registru
                definirano da poslovni subjekt zajednički zastupa više osoba?</strong
                >
            </li>
            </ol>
            <p>
            <span
                >Ako je u Sudskom registru definirano da poslovni subjekt zastupa više od jedne ovlaštene osobe, podatak o više ovlaštenih osoba prenosi se u e-Ovlaštenje. U OIB sustavu kao jednom od izvora podataka o ovlaštenim osobama ne prenosi se podatak jesu li te osobe ovlaštene za samostalno i pojedinačno zastupanje ili zastupaju poslovni subjekt zajedno s još nekom drugom ovlaštenom osobom (niti koja je to osoba). Sustav prilikom potpisivanja/potvrde Dokumenta ovlaštenja od strane Opunomoćitelja, kontrolira postojanje više ovlaštenih osoba, te postavlja pitanje Opunomoćitelju (inicijatoru skupnog potpisivanja) je li on ovlašten za samostalno ili pojedinačno potpisivanje/potvrdu. Ako Opunomoćitelj odgovori da nije ovlašten za samostalno i pojedinačno potpisivanje/potvrdu, pokreće se proces skupnog potpisivanja/potvrde, te mu sustav nudi popis svih ovlaštenih osoba poslovnog subjekta. Opunomoćitelj odabire osobe koje trebaju skupno potpisati/potvrditi Dokument ovlaštenja. Odabrane osobe dobivaju obavijest u svoj Korisnički pretinac da trebaju supotpisati/supotvrditi Dokument ovlaštenja. Nakon što sve odabrane osobe potpišu/potvrde Dokument ovlaštenja, provodi se kontrola skupnog potpisa/potvrde. Kontrola skupnog potpisa/potvrde provodi se i u situaciji ako Opunomoćitelj navede da je on ovlašten za samostalno i pojedinačno zastupanje. Kontrola skupnog potpisa/potvrde nije automatiziran proces te je moguće da postupak obrade traje određeno vrijeme. Rezultat kontrole može biti odobrenje skupnog potpisa/potvrde, čime Opunomoćenik dobiva poruku da može potpisati/potvrditi Dokument ovlaštenja ili odbijanje skupnog potpisa/potvrde, čime Opunomoćitelj – inicijator skupnog potpisa dobije poruku u svoj Korisnički pretinac da skupni potpis/potvrda nije odobren. Opunomoćitelj u tom slučaju može ažurirati listu potpisnika i odabrati nove osobe koje trebaju supotpisati/supotvrditi Dokument ovlaštenja. Proces skupnog potpisivanja/potvrde se ponavlja sve dok potpis/potvrda na Dokumentu ovlaštenja nije odobren.</span
            >
            </p>

            <ol start="26" type="1">
            <li>
                <strong
                >Kako se potpisuje/potvrđuje dokument ako je u Obrtnom registru definirano
                da obrt ima više vlasnika/privremenih upravitelja?</strong
                >
            </li>
            </ol>
            <p>
            <span
                >Ako u Obrtnom registru jedan obrt ima više vlasnika i/ili privremenih
                upravitelja, svi se oni smatraju zakonski ovlaštenim osobama za taj obrt. U
                Obrtnom registru nije dohvatljiv podatak jesu li te osobe ovlaštene za
                samostalno i pojedinačno zastupanje ili zastupaju poslovni subjekt zajedno s
                još jednom ovlaštenom osobom (niti koja je to osoba), pa se u sustav
                e-Ovlaštenja prenosi samo podatak da da za jedan obrt postoji više
                ovlaštenih osoba, i koje su to osobe.</span
            >
            </p>
            <p>
            <span
                >U tom slučaju, pokreće se proces skupnog potpisivanja/potvrde, te sve
                dohvatljive ovlaštene osobe dužne su supotpisati/supotvrditi Dokument
                ovlaštenja. Sustav nudi Korisniku popis svih ovlaštenih osoba poslovnog
                subjekta. Sve ovlaštene osobe dobivaju obavijest u svoj Korisnički pretinac
                da trebaju supotpisati/supotvrditi Dokument ovlaštenja. Nakon
                potpisa/potvrde svih ovlaštenih osoba nema provjere skupnog potpisa/potvrde
                već je Dokument ovlaštenja spreman za potpis/potvrdu Opunomoćenika.</span
            >
            </p>

            <ol start="27" type="1">
            <li>
                <strong>Kako izmijeniti/ažurirati postojeću rolu na e-usluzi?</strong>
            </li>
            </ol>
            <p>
            <span
                >Promjenu/ažuriranje rola moguće je izvršiti na Web registracijskom obrascu
                e-usluge. Iz postojećeg aktivnog Dokumenta ovlaštenja za pristup na e-uslugu
                potrebno je kreirati novi Dokument ovlaštenja na kojemu se definiraju nove
                role za korištenje e-usluge. Do Dokumenta ovlaštenja pristupa se preko
                Pregleda danih ovlaštenja. Samo aktivni Dokumenti ovlaštenja koji se odnose
                na pristup na e-usluge imaju mogućnost kreiranja novog iz postojećeg
                dokumenta. Odabirom Dokumenta ovlaštenja i opcije Kreiraj novi iz
                postojećeg, otvara se Web registracijski obrazac s postojećim rolama.
                Opunomoćitelj treba odabrati role koje će dodijeliti Opunomoćeniku. U
                trenutku kada se potpiše/potvrdi novi Dokument ovlaštenja od strane
                Opunomoćitelja i Opunomoćenika, sustav izvorni Dokument ovlaštenja
                ukida.</span
            >
            </p>
            <p>
            <span
                >Do kreiranja novog Dokumenta ovlaštenja iz postojećeg može se doći i kada
                Opunomoćitelj unosi podatke za pristup na e-uslugu Opunomoćeniku te sustav
                prepozna da takav Dokument ovlaštenja već postoji u sustavu. Tada sustav
                nudi Opunomoćitelju mogućnost kreiranja novog dokumenta iz postojećeg.</span
            >
            </p>

            <ol start="28" type="1">
            <li>
                <strong>što označavaju statusi Dokumenta ovlaštenja?</strong>
            </li>
            </ol>
            <p>
            <span>Statusi koje Korisnik može vidjeti u pregledima su:</span>
            </p>
            <p>
            <span></span>
            </p>
            <ul type="disc">
            <li>
                &bdquo;Dokument potpisan od strane e-Ovlaštenja&ldquo; &ndash; status
                Dokumenta ovlaštenja u trenutku kreiranja. Dokument ovlaštenja je potpisan
                samo od strane sustava, a nije potpisan/potvrđen od strane Opunomoćitelja
                niti Opunomoćenika. Dokument je spreman za potpis/potvrdu od strane
                Opunomoćitelja.
            </li>
            <li>
                &bdquo;Dokument potpisan/potvrđen od strane opunomoćitelja&ldquo; - status
                Dokumenta ovlaštenja koji je potpisan/potvrđen od strane Opunomoćitelja (i
                svih potrebnih Supotpisnika) ali nije potpisan/potvrđen od strane
                Opunomoćenika. Dokument je spreman za potpis/potvrdu od strane
                Opunomoćenika.
            </li>
            <li>
                &bdquo;Aktivan dokument&ldquo; - status Dokumenta ovlaštenja koji je potpisan/potvrđen  od strane Opunomoćitelja (i svih potrebnih Supotpisnika) i Opunomoćenika te je nastupio datum važenjaovlaštenja. Iznimno, ovo je status Dokumenta ovlaštenja koji je potvrđen samo od strane Opunomoćitelja (i svih potrebnih Supotpisnika) te je nastupio datum važenjaovlaštenja, ako se radi o davanju prava na pristup na e-uslugu koja je prilikom integracije uvjetovala da je dovoljno potvrditi Dokument samo od strane Opunomoćitelja.
            </li>
            <li>
                &bdquo;Istekao dokument&ldquo; - status aktivanog Dokumenta ovlaštenja nakon
                isteka definiranog vremena važenja.
            </li>
            <li>
                &bdquo;Poništen dokument&ldquo; - status neaktivanog Dokumenta ovlaštenja
                nakon procesa poništavanja od strane Opunomoćitelja, Opunomoćenika ili
                sustava.
            </li>
            <li>
                &bdquo;Provjera skupnog potpisa/potvrde na dokumentu&ldquo; - status koji
                može imati Dokument ovlaštenja onih poslovnih subjekata &ndash; pravnih
                osoba koji imaju više od jedne ovlaštene osobe za zastupanje. Dokument
                ovlaštenja se označava ovim statusom nakon potpisa/potvrde svih odabranih
                ovlaštenih osoba (Supotpisnika) sve dok se ne provjeri skupni potpis.
            </li>
            <li>
                &bdquo;Skupno potpisivanje/potvrda u tijeku&ldquo; - status koji može imati
                Dokument ovlaštenja onih poslovnih subjekata koji imaju više od jedne
                ovlaštene osobe za zastupanje. Dokument ovlaštenja se označava ovim statusom
                dok traje proces potpisivanja/potvrde između Supotpisnika.
            </li>
            <li>
                &bdquo;Potreban dodatni potpis/potvrda ovlaštene osobe na dokumentu&ldquo; -
                status koji može imati Dokument ovlaštenja onih poslovnih subjekata &ndash;
                pravnih osoba koji imaju više od jedne ovlaštene osobe za zastupanje.
                Dokument ovlaštenja se označava ovim statusom ako nije zadovoljena kontrola
                skupnog potpisa, pa Opunomoćitelj koji je inicijator skupnog potpisa treba
                ažurirati listu potpisnika.
            </li>
            <li>
                &bdquo;Opozvan/ukinut dokument&ldquo; - status aktivanog Dokumenta
                ovlaštenja nakon procesa opozivanja prava zastupanja odnosno ukidanja prava
                pristupa od strane Opunomoćitelja, Opunomoćenika ili sustava.
            </li>
            <li>
                &bdquo;Potpisan dokument koji čeka aktivaciju&ldquo; - status Dokumenta ovlaštenja koji je potpisan/potvrđen  od strane Opunomoćitelja (i svih potrebnih Supotpisnika) i Opunomoćenika, ali datum od kada vrijedi ovlaštenje još nije nastupio.
            </li>
            <li>
                &bdquo;Deaktiviran dokument zbog usklađivanja s vanjskim izvorima&ldquo; -
                status aktivanog ili neaktivanog Dokumenta ovlaštenja nakon deaktivacije od
                strane sustava.
            </li>
            </ul>

            <ol start="29" type="1">
            <li>
                <strong
                >Zašto u Pregledima danih/primljenih ovlaštenja vidim Dokumente ovlaštenja
                različitih statusa?</strong
                >
            </li>
            </ol>
            <p>
            <span
                >U Pregledu danih ovlaštenja Korisnik koji je ovlaštena osoba vidi pregled svih danih ovlaštenja u ime poslovnog subjekta (zastupanja i pristup na e-usluge). U Pregledu primljenih ovlaštenja Korisnik vidi pregled svih primljenih ovlaštenja na ime Korisnikaunutar poslovnog subjekta(zastupanja i pristup na e-usluge).</span
            >
            </p>

            <ol start="30" type="1">
            <li>
                <strong
                >Zašto u pregledu danih ovlaštenja više ne vidim dokumente ovlaštenja koje
                sam ranije vidio?</strong
                >
            </li>
            </ol>
            <p>
            <span
                >U Pregledu danih ovlaštenja Korisnik koji je ovlaštena osoba vidi pregled
                svih danih ovlaštenja u ime poslovnog subjekta (zastupanja i pristup na
                e-usluge). Ako Korisnik više nije ovlaštena osoba poslovnog subjekta, u
                Pregledu danih ovlaštenja ne vidi dana ovlaštenja za taj poslovni subjekt.
                Ako je Korisnik imao dodijeljena prava za zastupanje na e-Ovlaštenjima u
                Pregledu primljenih prava može provjeriti jesu li mu neka prava istekla ili
                su opozvana.</span
            >
            </p>

            <ol start="31" type="1">
            <li>
                <strong>Zašto ne vidim Pregled primljenih ovlaštenja?</strong>
            </li>
            </ol>
            <p>
            <span
                >Pregled primljenih ovlaštenja je pregled svih primljenih ovlaštenja na ime
                Korisnika unutar poslovnog subjekta. Pregled primljenih ovlaštenja se ne
                vidi ako je Korisnik na e-Ovlaštenjima prijavljen kao Opunomoćenik nekog
                poslovnog subjekta.</span
            >
            </p>

            <ol start="32" type="1">
            <li>
                <strong
                >Zašto se u Pregledu aktivnih primljenih ovlaštenja ne vidi Dokument
                ovlaštenja koji je potpisan/potvrđen od strane Opunomoćenika?</strong
                >
            </li>
            </ol>
            <p>
            <span
                >U Pregledu aktivnih ovlaštenja vide se sva aktivna ovlaštenja primljena na
                ime Korisnika unutar poslovnog subjekta. Dokumenti ovlaštenja koji su
                istekli ili su opozvani, ne prikazuju se u Pregledu aktivnih
                ovlaštenja.</span
            >
            </p>
            <ol start="33" type="1">
            <li>
                <strong
                >Ovlašten/a sam za zastupanje poslovnog subjekta. Zašto nemam pristup na
                e-uslugu?</strong
                >
            </li>
            </ol>
            <p>
            <span
                >Ako je e-usluga prilikom integracije na sustav e-Poslovanje definirala da je za pristup na uslugu potrebno imati dodijeljeno pravo pristupa , tada ovlaštene osobe poslovnih subjekata nemaju unaprijed definiranaprava pristupa na e-uslugu, već te podatke trebaju regulirati u e-Ovlaštenjima. Ovlaštena osoba unutar sustava e-Ovlaštenja treba samostalno regulirati prava pristupa i rolu na željenu uslugu.</span
            >
            </p>

            <p>
            <span></span>
            </p>

            <div class="btn-container">
                <button nz-button nzType="primary" (click)="openFAQDocument()">
                    {{ "EAUTHORISATION-OVERVIEW.FAQ.DOWNLOAD-FORM" | translate }}
                </button>
            </div>
        </div>
    </div>
</div>
